"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @file Created on Wed Feb 13 2019
 */

var immutable_1 = require("immutable");

var CodebookLookupSequence_1 = require("../../core/model/codebook/CodebookLookupSequence");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var SimulationValidator_1 = require("../validation/SimulationValidator");

var SimulationObject_1 = require("./SimulationObject");

var SimulationState_1 = require("./SimulationState");

var SimulationString_1 = require("./SimulationString");
/**
 * @author BPo
 * @author Tomas Leity
 */


var WindowSimulation =
/*#__PURE__*/
function (_SimulationObject_1$S) {
  _inherits(WindowSimulation, _SimulationObject_1$S);

  /**
   * @param id unique ID of this entity
   * @param simulationId ID of the {@link Simulation} entity
   * @param originId Id of {@link Window} element from which entity is based on.
   * @param state Aggregated simulation state of items in this window and its own simulated values.
   * @param windowTypeId Type of the window (like front page, bomba, regular, non-leaflet).
   * Changing this value for one Product transcribes the new value to
   * all other Products under the same Window, ie. it changes type for
   * whole Window.
   * @param name Name of the window. Changing this value for one Product transcribes
   * new value to all other Products under the same Window, ie. it rename
   * whole Window.
   * @param processedByCM
   */
  function WindowSimulation(id, simulationId) {
    var _this;

    var originId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var state = arguments.length > 3 ? arguments[3] : undefined;
    var windowTypeId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    var name = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
    var processedByCM = arguments.length > 6 ? arguments[6] : undefined;

    _classCallCheck(this, WindowSimulation);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowSimulation).call(this, state));
    _this.id = id;
    _this.simulationId = simulationId;
    _this.originId = originId;
    _this.state = state;
    _this.windowTypeId = windowTypeId;
    _this.name = name;
    _this.processedByCM = processedByCM;
    return _this;
  }
  /**
   * Converter from data-dictionary representation
   */


  _createClass(WindowSimulation, [{
    key: "hasNonRejectedSimulationValue",

    /**
     * Returns true if there is at least one filled simulation value that is not rejected and not all
     * acceptable values were rejected.
     */
    value: function hasNonRejectedSimulationValue() {
      return this.getValues().valueSeq().some(function (simValue) {
        return simValue !== null && !simValue.isRejected();
      });
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "getValues",
    value: function getValues() {
      return immutable_1.Map([[WindowSimulation.schema.name.simpleNameKey(), this.name], [WindowSimulation.schema.windowTypeId.simpleNameKey(), this.windowTypeId]]);
    }
    /**
     * Decides a simulation state based on simulated values.
     */

  }, {
    key: "computeSimulationState",
    value: function computeSimulationState() {
      var simulationValues = this.getValues().valueSeq();

      if (simulationValues.some(function (value) {
        return value !== null && value.accepted === null;
      })) {
        return SimulationState_1.SimulationState.Pending;
      }

      if (simulationValues.some(function (value) {
        return value !== null && value.accepted === false;
      })) {
        return SimulationState_1.SimulationState.Rejected;
      }

      return SimulationState_1.SimulationState.Empty;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "validator",
    value: function validator(type) {
      // INFO: Simulated values are the same in this simulation
      if (type === SimulationValidator_1.SimulationValidatorType.ACCEPTABLE) {
        return new SimulationValidator_1.SimulationValidator(SimulationValidator_1.SimulationValidatorType.ACCEPTABLE, this, this.getValues());
      }

      return new SimulationValidator_1.SimulationValidator(SimulationValidator_1.SimulationValidatorType.FULL, this, this.getValues());
    }
    /**
     * Gets status if simulation is processed by user. All simulation values are accepted/rejected.
     *
     * @returns {boolean} true if processed
     */

  }, {
    key: "isProcessed",
    value: function isProcessed() {
      return this.processedByCM;
    }
  }], [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new WindowSimulation(mat.id, mat.simulationId, mat.originId, mat.state, mat.windowTypeId, mat.name, mat.processedByCM);
    }
  }]);

  return WindowSimulation;
}(SimulationObject_1.SimulationObject);

exports.WindowSimulation = WindowSimulation;
WindowSimulation.DOCUMENT_TYPE = 'WindowSimulation';

WindowSimulation.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(WindowSimulation.name);
  return {
    id: builder.id('id'),
    simulationId: builder.id('simulationId'),
    originId: builder.opt(builder.id('originId')),
    state: builder.senum('state', SimulationState_1.SimulationState, CodebookLookupSequence_1.CodebookLookupSequence.SimulationState),
    windowTypeId: builder.opt(builder.obj('windowTypeId', SimulationString_1.SimulationString.schema, function (mat) {
      return SimulationString_1.SimulationString.fromDataDict(mat);
    })),
    name: builder.opt(builder.obj('name', SimulationString_1.SimulationString.schema, function (mat) {
      return SimulationString_1.SimulationString.fromDataDict(mat);
    })),
    processedByCM: builder.bool('processedByCM')
  };
}();